var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliverable
    ? _c(
        "div",
        { staticClass: "deliverable-projects" },
        [
          !_vm.disabled
            ? [
                !_vm.addProjectFlag
                  ? _c(
                      "div",
                      { staticClass: "pb-0 titles exclude-outside-click" },
                      [
                        _vm.deliverable.project_id
                          ? _c(
                              "div",
                              {
                                key:
                                  "deliverable-modal-department-" +
                                  _vm.deliverable.project_id.id,
                                staticClass:
                                  "department-title exclude-outside-click",
                                class: _vm.canEditDeliverableProject(
                                  _vm.deliverable.project_id
                                )
                                  ? ""
                                  : "pointer-default",
                                on: {
                                  click: function($event) {
                                    return _vm.goToProject(
                                      _vm.deliverable.project_id.id
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n      " +
                                    _vm._s(_vm.deliverable.project_id.name) +
                                    "\n      "
                                ),
                                _vm.deliverable.project_id.project_status &&
                                _vm.deliverable.project_id.project_status
                                  .slug &&
                                _vm.deliverable.project_id.project_status
                                  .slug == "on-hold"
                                  ? _c("span", [
                                      _vm._v(
                                        "\n        : \n        " +
                                          _vm._s(
                                            _vm.deliverable.project_id
                                              .project_status.name
                                          ) +
                                          "\n      "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.deliverable.project_id &&
                        _vm.getDeliverableTemplateSlug(
                          _vm.deliverable.deliverable_template_id
                        ) != "social-media"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "department-title exclude-outside-click",
                                on: {
                                  click: function($event) {
                                    return _vm.showAddProject()
                                  }
                                }
                              },
                              [_vm._v("No Project")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canEditDeliverableProject(
                          _vm.deliverable.project_id
                        ) &&
                        _vm.getDeliverableTemplateSlug(
                          _vm.deliverable.deliverable_template_id
                        ) != "social-media"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "plus-button plus-button--small exclude-outside-click",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.showAddProject()
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "exclude-outside-click",
                                  attrs: {
                                    src: require("@/csmworkflow/img/pencil.svg")
                                  }
                                })
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.addProjectFlag
                  ? _c("multiselect", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      ref: "deliverableProjects",
                      attrs: {
                        "close-on-select": true,
                        options: _vm.projectsOption,
                        "show-labels": false,
                        multiple: false,
                        taggable: false,
                        label: "name",
                        "track-by": "id",
                        "group-label": "group",
                        "group-values": "entries",
                        "group-select": false,
                        id: _vm.deliverable.deliverableId
                      },
                      on: {
                        input: function($event) {
                          return _vm.onProjectSelected(_vm.deliverable)
                        },
                        close: function($event) {
                          _vm.addProjectFlag = false
                        }
                      },
                      model: {
                        value: _vm.deliverable.project_id,
                        callback: function($$v) {
                          _vm.$set(_vm.deliverable, "project_id", $$v)
                        },
                        expression: "deliverable.project_id"
                      }
                    })
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  { staticClass: "pb-0 titles exclude-outside-click" },
                  [
                    _vm.deliverable.project_id
                      ? _c(
                          "div",
                          {
                            key:
                              "deliverable-modal-department-" +
                              _vm.deliverable.project_id.id,
                            staticClass:
                              "department-title exclude-outside-click",
                            class: _vm.canEditDeliverableProject(
                              _vm.deliverable.project_id
                            )
                              ? ""
                              : "pointer-default",
                            on: {
                              click: function($event) {
                                return _vm.goToProject(
                                  _vm.deliverable.project_id.id
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n    \t  " +
                                _vm._s(_vm.deliverable.project_id.name) +
                                "\n        "
                            ),
                            _vm.deliverable.project_id.project_status &&
                            _vm.deliverable.project_id.project_status.slug &&
                            _vm.deliverable.project_id.project_status.slug ==
                              "on-hold"
                              ? _c("span", [
                                  _vm._v(
                                    "\n          (" +
                                      _vm._s(
                                        _vm.deliverable.project_id
                                          .project_status.name
                                      ) +
                                      ")\n        "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.deliverable.project_id
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "department-title exclude-outside-click"
                          },
                          [_vm._v("No Project")]
                        )
                      : _vm._e()
                  ]
                )
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }